import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import { hide as hideElement, show as showElement } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';
import Keyboard from '@frontend/utils/keyboard';

export default class extends Controller {
  static targets = ['overlay', 'window', 'body'];
  static values = {
    confirmClose: { type: Boolean, default: false },
  };

  connect() {
    document.body.addEventListener(
      'modal-window:display',
      this.handleDisplay.bind(this)
    );
    document.body.addEventListener(
      'modal-window:load-and-display',
      this.loadAndDisplayUrl.bind(this)
    );
    document.body.addEventListener('modal-window:hide', this.hide.bind(this));

    Keyboard.map('escape', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.hide();
    });
  }

  display(html) {
    this.bodyTarget.innerHTML = html;
    if (html === null) {
      hideElement(this.windowTarget);
    } else {
      showElement(this.windowTarget);
    }
    this.disableBackgroundScrolling();
    this.previouslyActiveElement = document.activeElement;
    showElement(this.overlayTarget);
    this.bodyTarget.focus();
  }

  hide() {
    if(this.confirmCloseValue === false) {
      this._hide();
    } else {
      if(window.confirm("Bist du sicher?")) {
        this._hide();
      }
    }
  }

  _hide() {
    if (this.previouslyActiveElement) {
      this.previouslyActiveElement.focus();
      this.previouslyActiveElement = null;
    }
    this.reEnableBackgroundScrolling();
    hideElement(this.overlayTarget);
    this.bodyTarget.innerHTML = '';
  }

  async loadAndDisplay(url, confirmClose = false) {
    const response = await get(url);
    if (response.ok) {
      const html = await response.text;
      this.display(html);
      this.confirmCloseValue = confirmClose;
    }
  }

  disableBackgroundScrolling() {
    document.querySelector('html').classList.add('prevent-scroll');
  }

  reEnableBackgroundScrolling() {
    document.querySelector('html').classList.remove('prevent-scroll');
  }

  loadAndDisplayUrl(event) {
    const url = event.params?.url || event.detail?.url;
    const confirmClose = event.params?.confirmClose || event.detail?.confirmClose;
    this.loadAndDisplay(url, confirmClose);
  }

  handleDisplay({ detail: { html } }) {
    this.display(html);
  }
}

export function display(html) {
  dispatchCustomEvent('modal-window:display', { html });
}

export function loadAndDisplay(url, confirmClose) {
  dispatchCustomEvent('modal-window:load-and-display', { url, confirmClose });
}

export function hide() {
  dispatchCustomEvent('modal-window:hide');
}
